
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 9 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.634 1.099a.648.648 0 000-.91.633.633 0 00-.901 0L.449 7.545a.648.648 0 000 .91l7.284 7.356a.633.633 0 00.901 0 .648.648 0 000-.91L1.992 8l6.642-6.901z"}})])
          )
        }
      }
    